module.exports = __webpack_public_path__ + "img/home-nav-icon-2.4fe86a2f.png";